import { DownOutlined } from "@ant-design/icons";
import { Badge, Button, Dropdown, Menu, Select, Space } from "antd";
import React, { useState } from "react";

const { Option } = Select;

const JobTitleList: React.FC<any> = ({ jobTitles, smallText = false }) => {
  const [showAll, setShowAll] = useState(false);

  const displayedTitles = showAll ? jobTitles : jobTitles.slice(0, 4);
  const [selectedPool, setSelectedPool] = useState(2); // Default pool number

  const handleMenuClick = (e: any) => {
    const poolNumber = e.key; // Get the selected pool number
    setSelectedPool(poolNumber);
  };

  const handleShowMore = () => {
    setShowAll(true);
  };

  const menu = (
    <Menu onClick={handleMenuClick}>
      <Menu.Item key="1">Talent Pool 1</Menu.Item>
      <Menu.Item key="2">Talent Pool 2</Menu.Item>
      <Menu.Item key="3">Talent Pool 3</Menu.Item>
    </Menu>
  );

  return (
    <>
      <ul className="gap-1 flex items-center flex-wrap mt-2.5">
        <li>
          <p className={`text-text-quaternary font-semibold ${smallText ? "text-xs" : ""}`}>
            All Job Titles:
          </p>
        </li>
        {displayedTitles.map((job: any) => (
          <li
            key={job.id}
            className={`px-2.5 py-1.5 text-[#363f72] ${smallText ? "text-xs" : "text-sm"
              } font-medium bg-[#EFF4FF] rounded-full cursor-pointer`}
          >
            {job.designation}
          </li>
        ))}
        {!showAll && jobTitles.length > 4 && (
          <li
            onClick={handleShowMore}
            className={`px-2.5 py-1.5 text-[#363f72] ${smallText ? "text-xs" : "text-sm"
              } font-medium bg-[#EFF4FF] rounded-full cursor-pointer`}
          >
            +{jobTitles.length - 4}
          </li>
        )}
      </ul>
      {/* <Space size="small" wrap>
        <Button
          type="default"
          style={{
            display: "flex",
            alignItems: "center",
            gap: "6px",
            fontFamily: "Inter",
            fontSize: 12,
            fontWeight: 500,
            height: "28px",
            lineHeight: "1",
            padding: "0 8px",
          }}
        >
          <Badge color="#36BFFA" />
          Viewed
        </Button>

        <Button
          type="default"
          style={{
            display: "flex",
            alignItems: "center",
            gap: "6px",
            fontFamily: "Inter",
            fontSize: 12,
            fontWeight: 500,
            height: "28px",
            lineHeight: "1",
            padding: "0 8px",
          }}
        >
          <Badge color="#17B26A" />
          Contacted
        </Button>

        <Button
          type="default"
          style={{
            display: "flex",
            alignItems: "center",
            gap: "6px",
            fontFamily: "Inter",
            fontSize: 12,
            fontWeight: 500,
            height: "28px",
            lineHeight: "1",
            padding: "0 8px",
          }}
        >
          <Badge color="#D92D20" />
          Interviewed
        </Button>

        <Dropdown overlay={menu} trigger={['click']}>
          <Button
            type="default"
            style={{
              display: "flex",
              alignItems: "center",
              gap: "6px",
              backgroundColor: "#fff",
              fontFamily: "Inter",
              fontSize: 12,
              fontWeight: 500,
              height: "28px",
              lineHeight: "1",
              padding: "0 8px",
            }}
          >
            <Badge color="#9E77ED" />
            {`Added to Talent Pool (${selectedPool})`}
            <DownOutlined style={{ marginLeft: "6px" }} />
          </Button>
        </Dropdown>
      </Space> */}
    </>
  );
};

export default JobTitleList;
